import '@babel/polyfill';
import Vue from 'vue';
import App from './App.vue';
import { router } from '@/infrastructure';
import { store } from '@/store';

import '@/infrastructure/_filters';
import vuetify from '@/infrastructure/_vuetify';

Vue.config.productionTip = false;

new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
